import { init } from "./PARAMS";
import Model from "./Model";
export * from "./Components";
var Contabilidad = {
    Model: Model,
    init: init
};
export default Contabilidad;
